import { formatCurrencyAmount } from "../calculations";

/**
 * All PDF money amounts use full precision (2 decimal places).
 * Mixing summary cents with compact "K" / 1-decimal table cells looked inconsistent.
 */
export function summaryMoney(n: number, currency: string, locale: string): string {
  return formatCurrencyAmount(n, currency, locale, false);
}

/** Alias — same full-precision rule as summary lines. */
export function tableMoney(n: number, currency: string, locale: string): string {
  return formatCurrencyAmount(n, currency, locale, false);
}
